import CityZoneHub from "../components/CityZoneHub";

export default function Page() {
  return (
    <CityZoneHub
      name="Benalmádena"
      slug="benalmadena"
      poblacion={78787}
      lat={36.5988}
      lng={-4.5160}
      neighborhoodsText="Cubrimos Benalmádena Costa, Pueblo, Arroyo de la Miel, Torrequebrada y Reserva del Higuerón. Servicio en urbanizaciones y comunidades."
      faqItems={[
        { question: "¿Cuánto tarda en llegar el equipo a Benalmádena?", answer: "Visita en menos de 24h, generalmente el mismo día." },
        { question: "¿Trabajan en urbanizaciones cerradas de Benalmádena?", answer: "Sí, coordinamos con la administración o el conserje." },
        { question: "¿Atienden en inglés/francés?", answer: "Sí, atendemos en español, inglés y francés." },
      ]}
    />
  );
}